<template>
    <b-navbar type="dark" class="sub-header sub-header with-shadow">
        <back-button />

        <b-nav-text class="sub-header-text">
            {{ $translate(title) }}
        </b-nav-text>
    </b-navbar>
</template>

<script>
import BackButton from '../partials/BackButton'

export default {
    name: 'SubHeader',
    components: { BackButton },
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-header {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;

    .sub-header-text {
        font-size: 1.25rem;
        margin-left: 1.5rem;
    }
}
</style>
